import React, { useState, useEffect, Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import { Container, Divider, makeStyles } from "@material-ui/core";
import { txtA, txtE } from "../../../../Label/Lbl";
import moment from "moment";
import { useBody, useHeader } from "../../bill-template02/style";

function Header(props) {
    const { locInv, sta, info } = props;
    const clasm = useInvMain();
    const clas = useInvAF();
    const calssBody = useBody();
    const classHeader = useHeader();

    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const invColors = sta?.StngIA?.colors;
    const secondColor = getcolor(invColors);

    const styf = { fontWeight: "1200" };
    const stysub = { fontWeight: "bold", color: secondColor };
    const styfC = { fontWeight: "500" };
    function getcolor(text) {
        try {
            const obj = JSON.parse(text);
            for (let key in obj) {
                if (typeof obj[key] === "string" && obj[key].match(/^#[0-9A-Fa-f]{3,6}$/)) {
                    return obj[key];
                }
            }
        } catch {
            return "#31b835";

        }
    };


    return (
        <Fragment>
            <Grid
                item
                container
                style={{ paddingTop: 15, fontWeight: "bold",fontFamily: "Amiri-Regular", }}
            >
                {info?.header_img != null ? (
                    (
                        <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                            <div>
                                <ButtonBase>
                                    {" "}
                                    <img
                                        src={`data:image/jpeg;base64,${info.header_img}`}
                                        className={clas.headerImg}
                                        alt={info.nameA}
                                    />{" "}
                                </ButtonBase>
                            </div>
                        </Grid>
                    )
                ) :
                    (
                        <>
                            <Grid item xs={5} className={classHeader.leftHeaderen}>
                                <div style={styf}>{info.Disc1_header_en}</div>
                                <div style={stysub}>{info.Disc2_header_en}</div>
                                <div style={styfC}>{info.Disc3_header_en}</div>{" "}
                                <div style={styfC}>{info.Disc4_header_en}</div>
                            </Grid>

                            <Grid item xs={2} className={clasm.mincntr}>
                                <div>
                                    <ButtonBase>
                                        {" "}
                                        <img
                                            src={`data:image/jpeg;base64,${info.Logo}`}
                                            className={clas.Hedlogo}
                                            alt={info.nameA}
                                        />{" "}
                                    </ButtonBase>
                                </div>
                            </Grid>

                            <Grid item xs={5} className={classHeader.rightHeaderar}>
                                <div style={styf}>{info.Disc1_header_ar}</div>{" "}
                                <div style={stysub}>{info.Disc2_header_ar}</div>
                                <div style={styfC}>{info.Disc3_header_ar}</div>{" "}
                                <div style={styfC}>{info.Disc4_header_ar}</div>
                            </Grid>
                        </>
                    )
                }

            </Grid>
            <Container>
                <Divider style={{ background: secondColor, height: 1.5 }} />
                <Divider
                    style={{ background: secondColor, marginTop: 3, height: 1.5 }}
                />
            </Container>
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    style={{ direction: "rtl", paddingTop: "0.2rem" }}
                >
                    <Grid xs={3} item container style={{ paddingTop: 10 }}>
                        <Grid item xs={6} className={calssBody.txt}>
                            <div style={{ fontWeight: "bold",fontFamily: "Amiri-Regular", }}> {"التاريخ"}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={calssBody.minclr}>
                                {moment(sta?.tot?.date).format("YYYY/MM/DD")}
                            </div>
                        </Grid>
                    </Grid>
                    <Grid xs={6} item>
                        {locInv?.ProcTypeInvProc != "03" && locInv?.ProcTypeInvProc != "04" && (
                            <Typography
                                className={calssBody.minclr}
                                variant="h5"
                                gutterBottom
                            >
                                {/* {info.nameA} */}
                                {sta?.tot?.tax_no_cust === ""
                                    ? "فاتورة ضريبية مبسطة"
                                    : "فاتورة ضريبية"}
                            </Typography>
                        )}

                        {locInv?.ProcTypeInvProc == "03" || locInv?.ProcTypeInvProc == "04"
                            ? (
                                <Typography className={calssBody.minclr} variant="h6" gutterBottom>
                                    {locInv?.invN + " "}
                                </Typography>
                            ) :
                            (
                                <Typography className={calssBody.minclr} variant="h6" gutterBottom>
                                    {locInv?.invN + " "}
                                    {!premiApp?.hidePayType
                                        ? sta?.tot?.inv_type_name + " " + sta?.tot.pay_type_name
                                        : ""}
                                    {premiApp?.hidePayType && sta?.tot?.inv_type_name == "نقدية"
                                        ? sta?.tot?.inv_type_name
                                        : ""}
                                </Typography>
                            )}


                    </Grid>
                    <Grid
                        xs={3}
                        item
                        container
                        style={{
                            paddingTop: 10,
                            paddingLeft: 10,
                            direction: "ltr",
                            color: secondColor,
                        }}
                    >
                        <Grid item xs={6}>
                            <div
                                className={calssBody.txt}
                                style={{ fontWeight: "bold" }}
                            >
                                {" Inv No"}
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography className={calssBody.minclr}>
                           { premiApp.billTemplate !== 23? info?.MailBox :""} {sta?.tot?.id}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} className={calssBody.txt}>
                            Ref No
                        </Grid>
                        <Grid item xs={6}>
                            <Typography className={calssBody.minclr}>
                                {sta?.tot?.refno}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item container style={{ marginTop: 15 }}>
                        <Grid
                            item
                            xs={12}
                            className={calssBody.txt}
                            container
                            style={{ fontWeight: "bold" }}
                        >
                            <Grid item xs={1}>
                                {locInv?.ProcTypeInvProc == "01" || locInv?.ProcTypeInvProc == "11" 
                                || locInv?.ProcTypeInvProc == "04"?  "المورد" + "/":"العميل" + "/"}
                            </Grid>
                            <Grid item xs={5}>
                                {sta?.tot?.cust_name}
                            </Grid>
                            <Grid item xs={1}>
                                {"العنوان " + "/ "}
                            </Grid>
                            <Grid item xs={5}>
                                {sta?.tot?.cust_address}
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={2}></Grid> */}
                        <Grid
                            item
                            xs={12}
                            container
                            className={calssBody.txt}
                            style={{ fontWeight: "bold", paddingTop: 5 }}
                        >
                            <Grid item xs={2}>
                                {txtA.taxNumr + "/ "}
                            </Grid>
                            <Grid item xs={4}>
                                {sta?.tot?.tax_no_cust}
                            </Grid>
                            <Grid item xs={1}>
                                {"الهاتف " + "/ "}
                            </Grid>
                            <Grid item xs={5}>
                                {sta?.tot?.cust_mobile}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    );
}
export default Header;
